module.exports = __webpack_public_path__ + "img/news3-5.06997bf7.png";